'use strict';

var intellidealerAppEquipmentModule = angular.module('intellidealerApp.equipment',
                                                     ['intellidealerApp.core']);

